import useCountDownTime from "./updateCoundDown";
import React from "react";
import moment from "moment";
import "react-loading-skeleton/dist/skeleton.css";

const TimeCountDown = ({ leftDate, item, user, setsessionExpired }) => {
  const timeLeft = useCountDownTime(leftDate);

  return (
    <>
      {moment().isBefore(item.minted_start_date) ? (
        <>
          <h1 className="comming_soon_text">Auction coming soon </h1>
          {setsessionExpired(true)}
        </>
      ) : timeLeft?.days > 0 ||
        timeLeft?.hours > 0 ||
        timeLeft?.minutes > 0 ||
        timeLeft?.seconds > 0 ? (
        <div className="space-y-5">
          {setsessionExpired(false)}

          <div className="space-y-5 mt-5 aution_main_div">
            <div className="aution_ending_div">
              <svg width="32" height="32" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M12 20a8 8 0 0 0 8-8a8 8 0 0 0-8-8a8 8 0 0 0-8 8a8 8 0 0 0 8 8m0-18a10 10 0 0 1 10 10a10 10 0 0 1-10 10C6.47 22 2 17.5 2 12A10 10 0 0 1 12 2m.5 5v5.25l4.5 2.67l-.75 1.23L11 13V7h1.5Z"
                />
              </svg>
              <span className="sub_text text-white mt-1 ml-4">
                Auction ending in:
              </span>
            </div>

            <div className="time_count_down">
              <div className="flex flex-col ">
                <span className="headings_text">
                  {timeLeft?.days}
                  <br />
                </span>
                <span className="sub_text">Days</span>
              </div>

              <div className="flex flex-col ">
                <span className="headings_text">
                  {timeLeft?.hours}
                  <br />
                </span>
                <span className="sub_text">hours</span>
              </div>

              <div className="flex flex-col ">
                <span className="headings_text">
                  {timeLeft?.minutes}
                  <br />
                </span>
                <span className="sub_text">minutes</span>
              </div>

              <div className="flex flex-col ">
                <span className="headings_text">
                  {timeLeft?.seconds} <br />
                </span>
                <span className="sub_text">seconds</span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        item &&
        !item?.putOnSale && (
          <>
            <h1 className="comming_soon_text">Auctions has been Expired... </h1>
            {setsessionExpired(true)}
          </>
        )
      )}
    </>
  );
};

export default TimeCountDown;
